// extracted by mini-css-extract-plugin
module.exports = {"nps":"NPS_nps__NvajH","disabled":"NPS_disabled__tXfvH","label":"NPS_label__OBKqp"};